import React, { useEffect, useState } from 'react';
import { verifyPayment, getUserStatus } from '../services/api';

export default function PaymentSuccess({ onSuccess, onFailure }) {
  const [status, setStatus] = useState('verifying'); // verifying | success | failed

  useEffect(() => {
    const params  = new URLSearchParams(window.location.search);
    const orderId = params.get('order_id');
    const plan    = params.get('plan');
    const userId  = params.get('userId');

    if (!orderId || !userId || !plan) {
      setStatus('failed');
      return;
    }

    verifyPayment({ orderId, userId, plan })
      .then(({ data }) => {
        setStatus('success');
        // Update saved user in parent
        setTimeout(() => onSuccess(data), 2000);
      })
      .catch(() => {
        setStatus('failed');
        setTimeout(() => onFailure(), 3000);
      });
  }, []);

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#060a14', fontFamily: 'Syne, sans-serif'
    }}>
      <div style={{
        background: '#151e2e', border: '1px solid rgba(99,148,255,0.2)',
        borderRadius: '24px', padding: '48px 36px', textAlign: 'center',
        maxWidth: '420px', width: '90%'
      }}>
        {status === 'verifying' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '16px' }}>⏳</div>
            <h2 style={{ color: '#f0f4ff', marginBottom: '8px' }}>Verifying Payment...</h2>
            <p style={{ color: '#8ba3d4', fontSize: '0.9rem' }}>
              Please wait while we confirm your payment.
            </p>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '16px' }}>🎉</div>
            <h2 style={{ color: '#34d399', marginBottom: '8px' }}>Payment Successful!</h2>
            <p style={{ color: '#8ba3d4', fontSize: '0.9rem' }}>
              Your subscription is now active. Redirecting you back...
            </p>
          </>
        )}
        {status === 'failed' && (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '16px' }}>❌</div>
            <h2 style={{ color: '#f87171', marginBottom: '8px' }}>Payment Failed</h2>
            <p style={{ color: '#8ba3d4', fontSize: '0.9rem' }}>
              Something went wrong. Redirecting you back...
            </p>
          </>
        )}
      </div>
    </div>
  );
}